import { Skeleton } from '@zoomit/primitives';

export const SearchDialogSkeleton = () => {
  return (
    <div className="bg-background2 fixed top-0 left-0 z-[99999999] flex h-screen w-screen flex-col">
      <div className="flex w-full items-center justify-between px-4 py-3">
        <Skeleton width={3.2} height={3.2} variant="circular" />
        <Skeleton width={10.6} height={3.2} className="absolute left-1/2 -translate-x-1/2" />
      </div>
      <div className="mt-4 px-6">
        <Skeleton height={3.2} variant="circular" />
        <div className="flex flex-col gap-4">
          <Skeleton className="mt-6" height={2} width={10} variant="circular" />
          <div className="flex flex-col gap-2">
            <Skeleton height={1.6} className="mb-2" width={10} variant="circular" />
            <Skeleton height={1.6} className="mb-2" width={10} variant="circular" />
            <Skeleton height={1.6} className="mb-2" width={10} variant="circular" />
            <Skeleton height={1.6} className="mb-2" width={10} variant="circular" />
          </div>
        </div>
      </div>
    </div>
  );
};
